import clsx from 'clsx'
import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  variant?: 'primary' | 'ghost'
  href?: string
  target?: string
  onClick?: () => void
  type?: 'button' | 'submit'
  className?: string
  disabled?: boolean
  loading?: boolean
}

// Buttons: hover y:-1 + border brighten, press scale .98 (DESIGN.md §6).
export function Button({ children, variant = 'primary', href, target, onClick, type = 'button', className, disabled, loading }: Props) {
  const off = disabled || loading
  const cls = clsx('btn', `btn--${variant}`, off && 'btn--off', className)
  const motionProps = off ? {} : { whileHover: { y: -1 }, whileTap: { scale: 0.98 } }
  const content = (
    <>
      {loading && <span className="btn-spin" aria-hidden />}
      {children}
    </>
  )
  if (href && !off) {
    return (
      <motion.a className={cls} href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} onClick={onClick} {...motionProps}>
        {content}
      </motion.a>
    )
  }
  return (
    <motion.button type={type} className={cls} onClick={onClick} disabled={off} {...motionProps}>
      {content}
    </motion.button>
  )
}
